import { axiosMockAdapterInstance } from "apis";
import { getResponseData } from "mocksdata/index";

const charges = [
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "EXPIRED",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T08:14:25.118Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "EXPIRED",
        context: null,
        time: "2022-07-06T08:14:30.032Z",
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T08:14:25.107Z",
    createdAt: "2022-07-05T08:14:25.107Z",
    updatedAt: "2022-07-06T08:14:30.036Z",
    id: "62c3f2e16377f10006c78a1b",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - 5BZOHYCXYW8D",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "200000000",
    cryptoSlug: null,
    localPrice: {
      amount: "200000000",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.00001050936565242567",
      "doge-bsc-usd": "0.0684508363311277",
      "dai-bsc-usd": "0.9999364697572979",
      "ada-bsc-usd": "0.46338731770064584",
      "xrp-bsc-usd": "0.3248190126364425",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.00001007097797360038560162",
      "doge-bsc-eur": "0.0655954781444110391222",
      "dai-bsc-eur": "0.9582251198578419753994",
      "ada-bsc-eur": "0.44405757913008109943024",
      "xrp-bsc-eur": "0.311269512343325937555",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "19859044526189.126598395110339897",
        transferAmount: "19859044526189126598395110339897",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "3048990656.9427254",
        transferAmount: "304899065694272540",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "208719220.41625365871284176",
        transferAmount: "208719220416253658712841760",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "450392042.382892214867932993",
        transferAmount: "450392042382892214867932993",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "642530000.751897555211381952",
        transferAmount: "642530000751897555211381952",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/5BZOHYCXYW8D",
    code: "5BZOHYCXYW8D",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "EXPIRED",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T08:13:54.086Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "EXPIRED",
        context: null,
        time: "2022-07-06T08:14:00.041Z",
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T08:13:54.074Z",
    createdAt: "2022-07-05T08:13:54.074Z",
    updatedAt: "2022-07-06T08:14:00.045Z",
    id: "62c3f2c26377f10006c78a19",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - DW311ML301BX",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "100000000",
    cryptoSlug: null,
    localPrice: {
      amount: "100000000",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.00001050936565242567",
      "doge-bsc-usd": "0.0684508363311277",
      "dai-bsc-usd": "0.9999364697572979",
      "ada-bsc-usd": "0.46338731770064584",
      "xrp-bsc-usd": "0.3248190126364425",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.00001007097797360038560162",
      "doge-bsc-eur": "0.0655954781444110391222",
      "dai-bsc-eur": "0.9582251198578419753994",
      "ada-bsc-eur": "0.44405757913008109943024",
      "xrp-bsc-eur": "0.311269512343325937555",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "9929522263094.563299197555169473",
        transferAmount: "9929522263094563299197555169473",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "1524495328.4713627",
        transferAmount: "152449532847136270",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "104359610.20812682935642088",
        transferAmount: "104359610208126829356420880",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "225196021.191446107433966496",
        transferAmount: "225196021191446107433966496",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "321265000.375948777605690976",
        transferAmount: "321265000375948777605690976",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/DW311ML301BX",
    code: "DW311ML301BX",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "EXPIRED",
    localCurrency: "USD",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T08:11:52.144Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "EXPIRED",
        context: null,
        time: "2022-07-06T08:12:00.027Z",
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T08:11:52.130Z",
    createdAt: "2022-07-05T08:11:52.130Z",
    updatedAt: "2022-07-06T08:12:00.033Z",
    id: "62c3f2486377f10006c78a17",
    merchantId: "62bd217a6eb72b00083551b5",
    name: "INVOICE - YW2EK2OITFMJ",
    customerName: "",
    customerEmail: "minhnora98@gmail.com",
    amountRequested: "1",
    cryptoSlug: null,
    localPrice: {
      amount: "1",
      currency: "USD",
    },
    exchangeRates: {
      "bnb-bsc-usd": "232.7020409115987",
    },
    localExchangeRates: {
      "bnb-bsc-usd": "232.7020409115987",
    },
    addresses: {
      "bnb-bsc": {
        address: "0x0000000000000000000000000000000000000000",
        contract: "0x639a267B5ab969dD6790Ad72D6783b868af865f4",
        network: "binance-smart-chain-testnet",
        cmcId: 1839,
      },
    },
    pricing: {
      "bnb-bsc": {
        amount: "0.004297340908926065",
        transferAmount: "4297340908926065",
        decimal: 18,
        currency: "BNB",
        network: "binance-smart-chain-testnet",
        cmcId: 1839,
      },
    },
    exchangeRateByUSD: "1",
    fizenpayFeePerc: "0.5",
    hostedUrl: "https://dev-payment.fizen.io/charges/YW2EK2OITFMJ",
    code: "YW2EK2OITFMJ",
    merchant: {
      email: "minhbn@sotanext.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "EXPIRED",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T07:10:51.083Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "EXPIRED",
        context: null,
        time: "2022-07-06T07:11:00.034Z",
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T07:10:51.057Z",
    createdAt: "2022-07-05T07:10:51.057Z",
    updatedAt: "2022-07-06T07:11:00.039Z",
    id: "62c3e3fb668bbb0007cb78d3",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - YMUOIG597SYP",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "12",
    cryptoSlug: null,
    localPrice: {
      amount: "12",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.000010670023990897518",
      "doge-bsc-usd": "0.06922159763340673",
      "dai-bsc-usd": "1.000347067451555",
      "ada-bsc-usd": "0.46821300360390616",
      "xrp-bsc-usd": "0.32861727453183676",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.000010224934610141218934148",
      "doge-bsc-eur": "0.06633408790972680166478",
      "dai-bsc-eur": "0.95861858987988083473",
      "ada-bsc-eur": "0.44868196637157281844176",
      "xrp-bsc-eur": "0.31490933354201572139336",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "1173601.637324726639759091",
        transferAmount: "1173601637324726639759091",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "180.90246475",
        transferAmount: "18090246475",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "12.518013031130194623",
        transferAmount: "12518013031130194623",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "26.745001803933176803",
        transferAmount: "26745001803933176803",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "38.106206205536109512",
        transferAmount: "38106206205536109512",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/YMUOIG597SYP",
    code: "YMUOIG597SYP",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "NEW",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-06T03:26:01.496Z",
        context: null,
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-07T03:26:01.479Z",
    createdAt: "2022-07-06T03:26:01.479Z",
    updatedAt: "2022-07-06T03:26:01.479Z",
    id: "62c500c96377f10006c78a2f",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - 9O2G8CXCEABO",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "1000",
    cryptoSlug: null,
    localPrice: {
      amount: "1000",
      currency: "EUR",
    },
    exchangeRates: {
      "zsd-bsc-usd": "0",
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.00001023481606855275",
      "doge-bsc-usd": "0.06649816493591053",
      "bnb-bsc-usd": "230.07448141380888",
      "dai-bsc-usd": "0.9997574020785017",
      "ada-bsc-usd": "0.4514535076265468",
      "xrp-bsc-usd": "0.3215097351328073",
      "usdt-bsc-usd": "0.999048879168833",
    },
    localExchangeRates: {
      "zsd-bsc-eur": "0",
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.00000997690893844128925275",
      "doge-bsc-eur": "0.06482247767769052055453",
      "bnb-bsc-eur": "224.27683455666231003288",
      "dai-bsc-eur": "0.9745645153035255356617",
      "ada-bsc-eur": "0.4400773306878654471868",
      "xrp-bsc-eur": "0.3134080113171956888473",
      "usdt-bsc-eur": "0.973873846462657577233",
    },
    addresses: {
      "zsd-bsc": {
        address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 8772,
      },
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "bnb-bsc": {
        address: "0x0000000000000000000000000000000000000000",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 1839,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
      "usdt-bsc": {
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 825,
      },
    },
    pricing: {
      "zsd-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "ZSD",
        network: "binance-smart-chain-testnet",
        cmcId: 8772,
      },
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "100231445.046769348443787612",
        transferAmount: "100231445046769348443787612",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "15426.74757007",
        transferAmount: "1542674757007",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "bnb-bsc": {
        amount: "4.458775254148486273",
        transferAmount: "4458775254148486273",
        decimal: 18,
        currency: "BNB",
        network: "binance-smart-chain-testnet",
        cmcId: 1839,
      },
      "dai-bsc": {
        amount: "1026.099333904592914543",
        transferAmount: "1026099333904592914543",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "2272.32790754512200781",
        transferAmount: "2272327907545122007810",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "3190.728902548424481183",
        transferAmount: "3190728902548424481183",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
      "usdt-bsc": {
        amount: "1026.827040927568650413",
        transferAmount: "1026827040927568650413",
        decimal: 18,
        currency: "USDT",
        network: "binance-smart-chain-testnet",
        cmcId: 825,
      },
    },
    exchangeRateByUSD: "0.974801",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/9O2G8CXCEABO",
    code: "9O2G8CXCEABO",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [
      {
        crypto: "DOGE",
        cryptoAmount: "156.50113124",
        localAmount: "10",
        localCurrency: "EUR",
        transactionHash: "0x3b467f14197dcee1658248949da8a9ef34e1c9c8ae2b91c4b3c6ec6190cde5cd",
      },
    ],
    pricingType: "fixed_price",
    status: "COMPLETED",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T10:03:15.005Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "PENDING",
        context: null,
        time: "2022-07-06T02:51:56.923Z",
        transactionDetail: null,
      },
      {
        status: "COMPLETED",
        context: null,
        time: "2022-07-06T02:52:06.723Z",
        transactionDetail:
          "https://testnet.bscscan.com/tx/0x3b467f14197dcee1658248949da8a9ef34e1c9c8ae2b91c4b3c6ec6190cde5cd",
      },
    ],
    expiredAt: "2022-07-06T10:03:14.981Z",
    createdAt: "2022-07-05T10:03:14.981Z",
    updatedAt: "2022-07-06T02:52:06.726Z",
    id: "62c40c636377f10006c78a2c",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - E2E11QVUZNCZ",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "10",
    cryptoSlug: null,
    localPrice: {
      amount: "10",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.000010212800800839528",
      "doge-bsc-usd": "0.06667873860634448",
      "dai-bsc-usd": "0.9994682254715864",
      "ada-bsc-usd": "0.4541984357449018",
      "xrp-bsc-usd": "0.3197913128525837",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.000009786784028233307929008",
      "doge-bsc-eur": "0.06389730170411942636128",
      "dai-bsc-eur": "0.9577764079142646449104",
      "ada-bsc-eur": "0.4352520021962389663148",
      "xrp-bsc-eur": "0.3064515380282510235382",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "1021786.111878181644323968",
        transferAmount: "1021786111878181644323968",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "156.50113124",
        transferAmount: "15650113124",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "10.440850199867472617",
        transferAmount: "10440850199867472617",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "22.975195862491107653",
        transferAmount: "22975195862491107653",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "32.631586920207019062",
        transferAmount: "32631586920207019062",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/E2E11QVUZNCZ",
    code: "E2E11QVUZNCZ",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [
      {
        crypto: "DOGE",
        cryptoAmount: "10",
        localAmount: "0.65",
        localCurrency: "EUR",
        transactionHash: "0xac2bb7b73d42c10c8787c2964608386bf5c06fdfae72c134cc6569115cc75c9c",
      },
    ],
    pricingType: "fixed_price",
    status: "COMPLETED",
    localCurrency: "EUR",
    currencyType: "CRYPTO_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T09:14:24.469Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "PENDING",
        context: null,
        time: "2022-07-05T09:15:50.262Z",
        transactionDetail: null,
      },
      {
        status: "COMPLETED",
        context: null,
        time: "2022-07-05T09:15:58.004Z",
        transactionDetail:
          "https://testnet.bscscan.com/tx/0xac2bb7b73d42c10c8787c2964608386bf5c06fdfae72c134cc6569115cc75c9c",
      },
    ],
    expiredAt: "2022-07-06T09:14:24.458Z",
    createdAt: "2022-07-05T09:14:24.458Z",
    updatedAt: "2022-07-05T09:15:58.006Z",
    id: "62c400f06377f10006c78a28",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - Z0C4KEILIQJ6",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "10",
    cryptoSlug: "doge-bsc",
    localPrice: {
      amount: "0.64881172",
      currency: "EUR",
    },
    exchangeRates: {
      "doge-bsc-usd": "0.06770543654122316",
    },
    localExchangeRates: {
      "doge-bsc-eur": "0.06488117196134257710376",
    },
    addresses: {
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
    },
    pricing: {
      "doge-bsc": {
        amount: "10",
        transferAmount: "1000000000",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/Z0C4KEILIQJ6",
    code: "Z0C4KEILIQJ6",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "NEW",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T09:09:32.535Z",
        context: null,
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T09:09:32.524Z",
    createdAt: "2022-07-05T09:09:32.524Z",
    updatedAt: "2022-07-05T09:09:32.524Z",
    id: "62c3ffcc6377f10006c78a25",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - K48KF2A72EZ8",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "5060545",
    cryptoSlug: null,
    localPrice: {
      amount: "5060545",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.000010352844059919811",
      "doge-bsc-usd": "0.06777576462022666",
      "dai-bsc-usd": "0.9998477237186661",
      "ada-bsc-usd": "0.45931918873847655",
      "xrp-bsc-usd": "0.322514399374982",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.000009920985522804316003946",
      "doge-bsc-eur": "0.06494856637485852510476",
      "dai-bsc-eur": "0.9581400757714656623046",
      "ada-bsc-eur": "0.4401591480994397391933",
      "xrp-bsc-eur": "0.309061033719454000852",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "510084909242.923753973861860999",
        transferAmount: "510084909242923753973861860999",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "77916192.49595828",
        transferAmount: "7791619249595828",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "5281633.790263287849581052",
        transferAmount: "5281633790263287849581052",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "11497080.139878708937808995",
        transferAmount: "11497080139878708937808995",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "16373934.103234902472291435",
        transferAmount: "16373934103234902472291435",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/K48KF2A72EZ8",
    code: "K48KF2A72EZ8",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "NEW",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T09:08:43.438Z",
        context: null,
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T09:08:43.421Z",
    createdAt: "2022-07-05T09:08:43.421Z",
    updatedAt: "2022-07-05T09:08:43.421Z",
    id: "62c3ff9b6377f10006c78a23",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - O5J9LEKGF0K2",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "1000",
    cryptoSlug: null,
    localPrice: {
      amount: "1000",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.000010352844059919811",
      "doge-bsc-usd": "0.06777576462022666",
      "dai-bsc-usd": "0.9998477237186661",
      "ada-bsc-usd": "0.45931918873847655",
      "xrp-bsc-usd": "0.322514399374982",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.000009920985522804316003946",
      "doge-bsc-eur": "0.06494856637485852510476",
      "dai-bsc-eur": "0.9581400757714656623046",
      "ada-bsc-eur": "0.4401591480994397391933",
      "xrp-bsc-eur": "0.309061033719454000852",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "100796437.783464775824315686",
        transferAmount: "100796437783464775824315686",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "15396.79866417",
        transferAmount: "1539679866417",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "1043.688731206478323892",
        transferAmount: "1043688731206478323892",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "2271.905523985797762456",
        transferAmount: "2271905523985797762456",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "3235.606857212988417708",
        transferAmount: "3235606857212988417708",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/O5J9LEKGF0K2",
    code: "O5J9LEKGF0K2",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
  {
    transactionType: "INVOICE",
    amountReceived: [],
    pricingType: "fixed_price",
    status: "CANCELED",
    localCurrency: "EUR",
    currencyType: "LOCAL_CURRENCY",
    timeline: [
      {
        status: "NEW",
        time: "2022-07-05T07:11:45.092Z",
        context: null,
        transactionDetail: null,
      },
      {
        status: "CANCELED",
        context: null,
        time: "2022-07-05T07:14:43.095Z",
        transactionDetail: null,
      },
    ],
    expiredAt: "2022-07-06T07:11:45.082Z",
    createdAt: "2022-07-05T07:11:45.082Z",
    updatedAt: "2022-07-05T07:14:43.098Z",
    id: "62c3e431668bbb0007cb78d5",
    merchantId: "629dcf3ade243e00071bcde1",
    name: "INVOICE - OLII0CNMQ7LA",
    customerName: "",
    customerEmail: "hieunm286@gmail.com",
    amountRequested: "100",
    cryptoSlug: null,
    localPrice: {
      amount: "100",
      currency: "EUR",
    },
    exchangeRates: {
      "luna-bsc-usd": "0",
      "shib-bsc-usd": "0.000010670023990897518",
      "doge-bsc-usd": "0.06922159763340673",
      "dai-bsc-usd": "1.000347067451555",
      "ada-bsc-usd": "0.46821300360390616",
      "xrp-bsc-usd": "0.32861727453183676",
    },
    localExchangeRates: {
      "luna-bsc-eur": "0",
      "shib-bsc-eur": "0.000010224934610141218934148",
      "doge-bsc-eur": "0.06633408790972680166478",
      "dai-bsc-eur": "0.95861858987988083473",
      "ada-bsc-eur": "0.44868196637157281844176",
      "xrp-bsc-eur": "0.31490933354201572139336",
    },
    addresses: {
      "luna-bsc": {
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        contract: "0x47c3C3c758eEF8F00e120a75a55Cba8230d3bFEC",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    pricing: {
      "luna-bsc": {
        amount: "Infinity",
        transferAmount: "Infinity",
        decimal: 18,
        currency: "LUNA",
        network: "binance-smart-chain-testnet",
        cmcId: 4172,
      },
      "shib-bsc": {
        amount: "9780013.64437272199799336",
        transferAmount: "9780013644372721997993360",
        decimal: 18,
        currency: "SHIB",
        network: "binance-smart-chain-testnet",
        cmcId: 5994,
      },
      "doge-bsc": {
        amount: "1507.52053961",
        transferAmount: "150752053961",
        decimal: 8,
        currency: "DOGE",
        network: "binance-smart-chain-testnet",
        cmcId: 74,
      },
      "dai-bsc": {
        amount: "104.316775259418288527",
        transferAmount: "104316775259418288527",
        decimal: 18,
        currency: "DAI",
        network: "binance-smart-chain-testnet",
        cmcId: 4943,
      },
      "ada-bsc": {
        amount: "222.875015032776473356",
        transferAmount: "222875015032776473356",
        decimal: 18,
        currency: "ADA",
        network: "binance-smart-chain-testnet",
        cmcId: 2010,
      },
      "xrp-bsc": {
        amount: "317.551718379467579269",
        transferAmount: "317551718379467579269",
        decimal: 18,
        currency: "XRP",
        network: "binance-smart-chain-testnet",
        cmcId: 52,
      },
    },
    exchangeRateByUSD: "0.958286",
    fizenpayFeePerc: "33",
    hostedUrl: "https://dev-payment.fizen.io/charges/OLII0CNMQ7LA",
    code: "OLII0CNMQ7LA",
    remark: "g",
    merchant: {
      email: "hieunm286@gmail.com",
      name: null,
    },
    flexiblePaymentSettings: {
      type: "RELATIVE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "EUR",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "EUR",
    },
  },
];

export const onGetAllCharge = () => {
  axiosMockAdapterInstance.onGet("/charges").reply(() => {
    return [200, getResponseData(charges)];
  });
};
